<template>
    
  <div>

    <page-padding>
      <div v-if="!hasNewsletters">{{$t('language.no_documents')}}</div>
    </page-padding>

   <infinite-list v-if="hasNewsletters" :list='newsletters["0newsletters"]'>

        <template v-slot:default="newsletters">
          <button-newsletter :item="newsletters.item"/>
      </template>
    </infinite-list>


  </div>
</template>

<script>

import { mapState } from 'vuex';
import PagePadding from '../../components/PagePadding';
import InfiniteList from '../../components/InfiniteList.vue';
import ButtonNewsletter from './ButtonNewsletter.vue';
import { eventBus } from '../../services/EventBus.js';

export default {
  name: 'list-newsletters',
  props:{
  },
  data:function(){
    return {
    }
  },
  components:{
    PagePadding,
    InfiniteList,
    ButtonNewsletter,
  },
  methods:{
     emitLoadStart(){
      // emit to all parent who want to hear..
      let vm=this.$parent;
      while(vm){
        vm.$emit('SCROLLPAGE_START_LOAD')
        vm=vm.$parent;
      }
    },
    emitLoadEnd(){
      // emit to all parent who want to hear..
      let vm=this.$parent;
      while(vm){
        vm.$emit('SCROLLPAGE_END_LOAD')
        vm=vm.$parent;
      }
    },
    load_newletters(){
      this.emitLoadStart();
      this.$store.dispatch('get_newsletters',{store_key:"0newsletters",id:0}).then(()=>{
        this.emitLoadEnd();
      })
    }
  },
  computed:{
    ...mapState([
       'newsletters',
       ]),
       hasNewsletters:function(){
         if(this.newsletters["0newsletters"]){
           return this.newsletters["0newsletters"] ? this.newsletters["0newsletters"].length : false
         }else{
           return false;
         }
       }
  },
  beforeDestroy(){
   
      eventBus.$off("RELOAD_FROM_PULL",this.load_newletters)
    },
  created:function(){
    this.load_newletters();
    eventBus.$on("RELOAD_FROM_PULL",this.load_newletters)
  },  
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>



</style>

